import React, { useState } from "react";
import { SettingContentType } from "../../recoil/settings";
import { useToast } from "../../controller/ToastController";

interface SettingProps {
  mainKey: string;
  subKey: string;
  item: SettingContentType;
  editSetting: (key: string, subKey: string, value: string) => void;
}

const InputSetting = ({ mainKey, subKey, item, editSetting }: SettingProps) => {
  const showToast = useToast();
  const [value, setValue] = useState<string>(String(item.value));

  return (
    <div className="itemWrap">
      <h2 className="title">{item.name}</h2>
      <div className="content">
        <input value={value} onChange={(e) => setValue(e.target.value)} />
        <button
          className="save"
          onClick={() => {
            editSetting(mainKey, subKey, value);
            showToast("입력한 설정을 변경했어요");
          }}
        >
          <h2>저장</h2>
        </button>
      </div>
    </div>
  );
};
export default InputSetting;
